import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  property: [],
  getAllProperty: [],
  getSingleProperty: [],
};

export const ProductSlice = createSlice({
  name: "property",
  initialState,
  reducers: {
    getPropertyAction: (state, action) => {
      state.property = action.payload;
    },
    getSingleProperty: (state, action) => {
      state.getSingleProperty = action.payload;
    }
  },
});

export default ProductSlice.reducer;

export const { getPropertyAction, getSingleProperty } = ProductSlice.actions;
